// import { mutateHiveStats } from "../hiveMutations.js";
import { convertGameTime } from "../utils.js";
import { hiveState, inventoryState, playerState } from "./stateManager.js";
const w = new Worker("mutationWorker.js");
export default function globalStateManager() {
  let instance = null;
  function createInstance() {
    let gameStart = null;
    let gameObject;
    let coins = 0;
    let gameTime = 0;
    let lastMutation = null;
    let freezePlayer = false;
    let startGameDate = 106;
    const speed = 24;
    let gameDate = null;
    let currentGame = null;
    let clockTimer;
    //start the clock
    function startGameClock(gTime, slot) {
      clockTimer = setInterval(() => {
        gameMutation(slot);
      }, 5000);
    }
    function cancelGameClock() {
      if (clockTimer) {
        clearInterval(clockTimer);
      }
    }
    function gameMutation(slot) {
      let now = new Date().getTime();
      gameTime = (now - gameStart) * speed;

      let hives = hiveState.getHives();
      let positions = hiveState.getHomeYard1Positions();
      const inventory = inventoryState.getInventory();
      console.log("inventory: ", inventory);
      const player = playerState.getPlayer();
      const content = playerState.getContent();
      console.log("content is: ", content);

      let g = {
        gameStart: gameStart,
        hives: hives,
        lastMutation: lastMutation,
        coins: coins,
        inventory: inventory,
        homeYard1Positions: positions,
        player: player,
        content: content,
        active: true,
        apiaryName: game.apiaryName,
        mode: game.mode,
      };
      gameObject[slot] = g;

      localStorage.setItem("gameObject", JSON.stringify(gameObject));

      let convertedTime = convertGameTime(gameTime);

      //game days since game start
      let days = startGameDate + convertedTime.days;
      let dayOfYear;
      let years;

      dayOfYear = days % 365;
      years = Math.floor(days / 365);
      gameDate = {
        dayOfYear: dayOfYear,
        days: days,
        years: years,
        min: convertedTime.min,
        hours: convertedTime.hours,
      };
      console.log("dayOfYear is ", dayOfYear, " years is ", years);
      nature(hives, gameTime, now);
      healWounds(now);
      //mutate player stings (reduce amount over time)
    }
    function healWounds(now) {
      let content = playerState.getContent();
      if (content.stings.count > 0) {
        console.log("healing wounds");
        for (let i = 0; i < content.stings.stings.length; i++) {
          if ((now - content.stings.stings[i]) * speed > 86400000) {
            console.log("wound older than day, removing");
            content.stings.stings.splice(i, 1);
            content.stings.count = content.stings.count - 1;
          }
        }
      }
      playerState.setContent(content);
    }
    w.addEventListener("message", (event) => {
      console.log("got worker response");
      hiveState.setHives(event.data.hives);
      const inv = inventoryState.getInventory();
      inv.honeyStand = event.data.inventory.honeyStand;
      inventoryState.setInventory(inv);
    });
    function nature(hives, gTime, now) {
      const inventory = inventoryState.getInventory();
      w.postMessage({ hives, gTime, now, speed, startGameDate, inventory });

      lastMutation = now;
    }
    return {
      setCoins: (value) => {
        coins = value;
      },
      getCoins: () => {
        return coins;
      },
      setGameObject: (value) => {
        gameObject = value;
      },
      getGameObject: () => {
        return gameObject;
      },
      getGameTime: () => {
        return gameTime;
      },
      setGameTime: (value) => {
        gameTime = value;
      },
      setLastMutation: (value) => {
        lastMutation = value;
      },
      setFreezePlayer: (value) => {
        freezePlayer = value;
      },
      getLastMutation: () => {
        return lastMutation;
      },
      getGameSpeed: () => {
        return speed;
      },
      getGameDate: () => {
        return gameDate;
      },
      getFreezePlayer: () => {
        return freezePlayer;
      },
      cancelGame: () => {
        cancelGameClock();
      },
      setGameStart: (value, isNew, game, slot) => {
        console.log("setGameStart: ", slot);
        currentGame = game[slot];
        if (isNew) {
          gameStart = value;
          lastMutation = gameStart;
          gameTime = 0;
          coins = 2000;
          gameObject = game;
          console.log("gameObject before: ", gameObject);
          playerState.setPlayer(currentGame.player);
          startGameClock(gameTime, slot);
        } else {
          gameStart = value;
          gameObject = game;
          playerState.setPlayer(currentGame.player);
          gameMutation(slot);
          startGameClock(gameTime, slot);

          lastMutation = gameObject.lastMutation;
          if (!lastMutation) {
            lastMutation = value;
          }
        }
      },
      changeGameStart: (value) => {
        gameStart = value;
      },
      getGameStart: () => {
        return gameStart;
      },
      getCurrentGame: () => {
        return currentGame;
      },
    };
  }
  return {
    getInstance: () => {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    },
  };
}
